import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gravel-prices',
  templateUrl: './gravel-prices.component.html',
  styleUrls: ['./gravel-prices.component.css']
})
export class GravelPricesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
